import type { BucketRegion } from '@/entities/bucket';
import request from '@/shared/api/request';

export const getBucketsRegions = (): Promise<{ regions: BucketRegion[] }> =>
  request({
    url: '/buckets/regions/',
  });
